import {
  LOCAL_STORAGE_KEY,
  SESSION_STORAGE_KEY,
  HEADER_DEVICE_TYPE_BREAKPOINT,
  REFERRER_STORAGE_KEY,
} from 'define';
import { modal as modalStore } from 'store';

export const lockUnlockPage = {
  lock: () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.setAttribute(
      'style',
      `overflow: hidden; padding-right: ${scrollbarWidth}px`,
    );
    document.querySelectorAll('.fixed-element').forEach(el => {
      el.style.paddingRight = `${scrollbarWidth}px`;
    });
  },
  unlock: () => {
    document.documentElement.setAttribute('style', '');
    document.querySelectorAll('.fixed-element').forEach(el => {
      el.style.paddingRight = '';
    });
  },
};

export const getEntryPointsFromStorages = point => {
  if (point === 'first') {
    return { firstPoint: window.localStorage.getItem(LOCAL_STORAGE_KEY) };
  }

  if (point === 'session') {
    return { sessionPoint: window.sessionStorage.getItem(SESSION_STORAGE_KEY) };
  }

  return {
    firstPoint: window.localStorage.getItem(LOCAL_STORAGE_KEY),
    sessionPoint: window.sessionStorage.getItem(SESSION_STORAGE_KEY),
  };
};

export const getReferrer = () => {
  const documentReferrer = document.referrer;
  const storageReferrer = window.localStorage.getItem(REFERRER_STORAGE_KEY);

  return storageReferrer || documentReferrer || 'direct';
};

export function distinct(arr) {
  return Object.keys(
    arr.reduce(
      (acc, item) => ({
        ...acc,
        [item.trim()]: true,
      }),
      {},
    ),
  );
}

export function throttle(func, ms, withLastCall = true) {
  let isThrottled = false;
  let savedArgs = null;
  let lastResult = null;

  function wrapper(...args) {
    if (isThrottled) {
      savedArgs = args;
      return lastResult;
    }

    lastResult = func(...args);

    isThrottled = true;

    setTimeout(() => {
      isThrottled = false;

      if (withLastCall && savedArgs) {
        wrapper(...savedArgs);
        savedArgs = null;
      }
    }, ms);

    return lastResult;
  }

  return wrapper;
}

export function debounce(f, ms) {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      f.apply(this, args);
    }, ms);
  };
}

export function upperFirst(str) {
  const result = str;
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export function isEmpty(value) {
  return (
    value == null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  );
}

export function isStaticLink(link) {
  return (
    (link?.includes('static.andersenlab.com') || link?.includes('content.andersenlab.com')) ?? false
  );
}

export function handleGLobalLinksInText(textRef) {
  const links = textRef.current?.querySelectorAll('a');

  if (!links) return;

  const handleClick = href => e => {
    e.preventDefault();
    modalStore.open('LangNotificationModal', { href });
  };

  links.forEach(element => {
    if (element.href.startsWith('https://andersenlab.com')) {
      element.onclick = handleClick(element.href);
    }
  });
}

export const getHeaderDeviceType = width => {
  return width <= HEADER_DEVICE_TYPE_BREAKPOINT ? 'Mobile' : 'Desktop';
};

const addThousandsSeparator = (numStr, separator) => {
  const startsWithMinus = numStr[0] === '-';
  const digitStartIndex = startsWithMinus ? 1 : 0;
  let currentIndex = digitStartIndex;

  while (currentIndex < numStr.length) {
    const char = numStr[currentIndex];
    if (char < '0' || char > '9') break;
    currentIndex += 1;
  }

  if (currentIndex === digitStartIndex) return numStr;

  const digits = numStr.slice(digitStartIndex, currentIndex);
  if (digits.length <= 3) return numStr;

  let grouped = '';
  let count = 0;

  for (let i = digits.length - 1; i >= 0; i -= 1) {
    grouped = digits[i] + grouped;
    count += 1;

    if (count % 3 === 0 && i !== 0) {
      grouped = separator + grouped;
    }
  }

  const sign = startsWithMinus ? '-' : '';
  const suffix = numStr.slice(currentIndex);

  return `${sign}${grouped}${suffix}`;
};

export const formatNumber = number => {
  const lang = process.env.GATSBY_LANG || 'en';
  const numStr = number.toString();

  if (['en', 'ae', 'pl', 'kz', 'uk'].includes(lang)) {
    return addThousandsSeparator(numStr, ',');
  }

  if (['de', 'nl'].includes(lang)) {
    return addThousandsSeparator(numStr, '.');
  }

  if (['fr', 'az'].includes(lang)) {
    return addThousandsSeparator(numStr, ' ');
  }

  return numStr;
};

export { default as getYoutubeId } from './getYoutubeId';
